import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss']
})
export class MenuButtonComponent implements OnInit {
  @Input() active = false;
  @Output() menuStatus = new EventEmitter();
  // public active = false;
  constructor() {}

  ngOnInit(): void {}

  toogle(): void {
    this.active = !this.active;
    this.menuStatus.emit(this.active);
  }
}